import React from 'react';
import { ErrorMessage, Field, FormikProps } from 'formik';

export default function TextArea(props: {
    name: string;
    formik: FormikProps<any>;
    placeholder?: string;
    label?: string;
    className?: string;
    disabled?: boolean;
    fieldClass?: string;
    labelClass?: string;
    rows?: number;
}) {
    return (
        <div className={props.className}>
            {props.label && (
                <label htmlFor={`textarea-${props.name}`} className={props.labelClass}>
                    {props.label}
                </label>
            )}
            <Field
                disabled={props.disabled}
                as={'textarea'}
                name={props.name}
                rows={props.rows}
                id={`textarea-${props.name}`}
                className={`focus-effect standard-behavior type-blue mb-0 w-full
                ${
                    props.formik.errors[props.name] &&
                    props.formik.touched[props.name] &&
                    'is-invalid'
                } mb-1 rounded px-2 py-1 ${props.fieldClass} min-h-[34px]`}
                placeholder={props.placeholder}
            />
            <small className={'text-red-500'}>
                <ErrorMessage name={props.name} />
            </small>
        </div>
    );
}
